import { styled } from "@mui/material";

export const WhiteButton = styled("button")(() => ({
  "--button-radius": "100em",
  "--button-medium": "40px",

  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  height: "var(--button-medium)",
  padding: "0 16px",
  borderRadius: "var(--button-radius)",
  border: "1px solid var(--color-primary)",
  backgroundColor: "var(--color-surface)",
  color: "var(--color-primary)",
  fontSize: "14px",
  fontWeight: 600,
  cursor: "pointer",
  transition: "background-color 0.2s, color 0.2s, transform 0.1s",

  "&:hover": {
    backgroundColor: "var(--color-gray-40)",
    color: "var(--color-surface)",
  },
  "&:active": {
    backgroundColor: "var(--color-primary-hover)",
    color: "var(--color-surface)",
    transform: "translateY(1px)",
  },
  "&:focus-visible": {
    outline: "2px solid var(--color-primary)",
    outlineOffset: "2px",
  },
  "&:disabled": {
    cursor: "not-allowed",
    opacity: 0.6,
  },
}));
